import { useUser } from "@clerk/clerk-expo";
import PostLoginAccessProvider from "@contexts/PostLoginAccessProvider";
import DocumentTitle from "components/DocumentTitle";
import { Redirect, Stack } from "expo-router";

const PostLoginRoute = () => {
	const { isLoaded, isSignedIn } = useUser();

	if (!isLoaded) {
		return null;
	}

	if (!isSignedIn) {
		return <Redirect href="/(auth)/login" />;
	}

	return (
		<>
			<Stack.Screen
				options={{
					headerShown: false,
				}}
			/>
			<DocumentTitle title="Activating access" />
			<PostLoginAccessProvider />
		</>
	);
};

export default PostLoginRoute;
